import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { chPerm } from 'src/components/helpers';
import {
  Sidebar,
  MainContent,
  ContentWrapper,
  MainHeader,
  MobileMenuButton,
  Overlay,
} from './styles/HomeStyles';
import authService from 'src/services/api/auth';
import { screenSizes } from 'src/assets/styles/Literals';
import { Icon } from 'semantic-ui-react';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const currentUser = authService.getCurrentUser();
  const userName = currentUser?.name || currentUser?.firstName || 'Usuario';
  const userRole = currentUser?.role || 'Staff';
  const userInitials = userName
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
  const isAdmin = chPerm(['intranetAdmin'], true);

  // Close sidebar when route changes on mobile
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  // Close sidebar on window resize if above tablet size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > parseInt(screenSizes.tablet)) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Determine heading based on route
  const getHeading = () => {
    if (location.pathname === '/intranet/institutional') {
      return 'Nuestra Identidad';
    }
    if (location.pathname === '/intranet/asignaciones') {
      return 'Tus asignaciones';
    }
    if (location.pathname === '/intranet/usuarios') {
      return 'Gestión de Usuarios';
    }
    return 'Intranet'; // Default
  };

  const handleLogout = () => {
    authService.logout();
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', position: 'relative' }}>
      <MobileMenuButton onClick={toggleSidebar} aria-label="Toggle menu">
        {sidebarOpen ? <Icon name="close" /> : <Icon name="sidebar" />}
      </MobileMenuButton>

      <Overlay $isOpen={sidebarOpen} onClick={closeSidebar} />

      <Sidebar $isOpen={sidebarOpen}>
        <div className="sidebar-header">
          <h1>Portal Comunidad</h1>
          <p>Intranet Colaboradores</p>
        </div>

        <nav className="sidebar-nav">
          <NavLink
            to="/intranet/institutional"
            className="nav-button"
            activeClassName="active"
            exact
            onClick={closeSidebar}
          >
            <span>Institucional</span>
          </NavLink>
          <NavLink
            to="/intranet/asignaciones"
            className="nav-button"
            activeClassName="active"
            exact
            onClick={closeSidebar}
          >
            <span>Asignaciones</span>
          </NavLink>
          {isAdmin && (
            <NavLink
              to="/intranet/usuarios"
              className="nav-button"
              activeClassName="active"
              exact
              onClick={closeSidebar}
            >
              <span>Usuarios</span>
            </NavLink>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{userInitials}</div>
            <div className="user-details">
              <div className="user-name">{userName}</div>
              <div className="user-role">{userRole}</div>
            </div>
          </div>
          <button onClick={handleLogout} className="logout-button">
            <i className="fa-solid fa-right-from-bracket"></i>
            <span>Cerrar Sesión</span>
          </button>
        </div>
      </Sidebar>

      <MainContent>
        <MainHeader>
          <div className="header-title">
            <h2>{getHeading()}</h2>
            <span className="date-display">
              {new Date().toLocaleDateString('es-ES', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </span>
            <p>Bienvenido de nuevo, {userName.split(' ')[0]}.</p>
          </div>
          <div className="header-actions">
            <div className="divider"></div>
          </div>
        </MainHeader>
        <ContentWrapper>{children}</ContentWrapper>
      </MainContent>
    </div>
  );
};

export default Layout;
